var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Connect"},[(_vm.isSubmitting)?_c('div',{staticClass:"centered"},[_c('div',{staticClass:"is-loading mb-4"}),_c('div',{},[_vm._v("\n\t\t\tSedang memuat, mohon untuk tidak menutup window ini!\n\t\t")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }